import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

import VueApexCharts from "vue3-apexcharts";

import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import de from "./locales/de.json";
import "@mdi/font/css/materialdesignicons.css";
import "aos/dist/aos.css";

const messages = {
  en,
  de
};
const savedLang = localStorage.getItem("lang") || "en";

const i18n = createI18n({
  legacy: false,
  locale: savedLang,
  fallbackLocale: "en",
  messages
});

const vuetify = createVuetify({
  components,
  directives
});

const app = createApp(App);
app.use(store);
app.use(router);
app.use(vuetify);
app.use(i18n);
app.use(VueApexCharts);

app.mount("#app");
